import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, withModifiers as _withModifiers, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TextFieldGroup = _resolveComponent("TextFieldGroup")!
  const _component_ValidationProvider = _resolveComponent("ValidationProvider")!
  const _component_BForm = _resolveComponent("BForm")!
  const _component_AppButton = _resolveComponent("AppButton")!
  const _component_CustomValidationObserver = _resolveComponent("CustomValidationObserver")!

  return (_openBlock(), _createBlock(_component_CustomValidationObserver, {
    tag: "div",
    class: "form-container"
  }, {
    default: _withCtx(({ handleSubmit }) => [
      _createVNode(_component_BForm, {
        class: "mt-3",
        onSubmit: _withModifiers(($event: any) => (handleSubmit(_ctx.submit)), ["stop","prevent"])
      }, {
        default: _withCtx(() => [
          _createVNode(_component_ValidationProvider, {
            name: "コード",
            rules: { required: true, numeric: true, min: 4, max: 4 },
            modelValue: _ctx.officeCode,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.officeCode) = $event))
          }, {
            default: _withCtx((validationState) => [
              _createVNode(_component_TextFieldGroup, {
                modelValue: _ctx.officeCode,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.officeCode) = $event)),
                placeholder: "0000",
                inputmode: "numeric",
                formatter: _ctx.sliceString,
                class: "input",
                "validation-state": validationState
              }, null, 8, ["modelValue", "formatter", "validation-state"])
            ]),
            _: 1
          }, 8, ["modelValue"])
        ], undefined, true),
        _: 2
      }, 1032, ["onSubmit"]),
      _createTextVNode(),
      (_ctx.workStatus === 'start')
        ? (_openBlock(), _createBlock(_component_AppButton, {
            key: 0,
            variant: "secondary",
            block: "",
            class: "mt-4",
            onClick: ($event: any) => (handleSubmit(_ctx.submit))
          }, {
            default: _withCtx(() => [
              _createTextVNode("\n      仕事開始\n    ")
            ], undefined, true),
            _: 2
          }, 1032, ["onClick"]))
        : _createCommentVNode("", true),
      _createTextVNode(),
      (_ctx.workStatus === 'finish')
        ? (_openBlock(), _createBlock(_component_AppButton, {
            key: 1,
            variant: "secondary",
            block: "",
            class: "mt-4",
            onClick: ($event: any) => (handleSubmit(_ctx.submit))
          }, {
            default: _withCtx(() => [
              _createTextVNode("\n      仕事終了\n    ")
            ], undefined, true),
            _: 2
          }, 1032, ["onClick"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}